export const creamTokens = {
  color: {
    rose: "#D86B8A",
    roseDeep: "#B94F72",
    roseSoft: "#F8DDE6",
    roseMist: "#FFF0F5",
    cream: "#FFF7F4",
    creamDeep: "#F7ECE7",
    warmBeige: "#FBF1EC",
    chocolate: "#7A4E3A",
    chocolateSoft: "#E9D6CD",
    ink: "#2E2420",
    muted: "#7F6D66",
    line: "#EADDD8",
    lineStrong: "#DCCBC4",
    surface: "#FFFFFF",
    success: "#1F9D6A",
    warning: "#E5A93D",
    critical: "#E25555",
    info: "#6E7FD8",
    violet: "#8C6AD9"
  },
  spacing: {
    xs: 4,
    sm: 8,
    md: 12,
    lg: 16,
    xl: 20,
    "2xl": 24,
    "3xl": 32
  },
  radius: {
    control: 12,
    medium: 16,
    card: 24,
    panel: 28,
    pill: 999
  },
  shadow: {
    card: "0 18px 50px rgba(122, 78, 58, 0.10)",
    hover: "0 26px 70px rgba(122, 78, 58, 0.16)",
    glass: "0 16px 42px rgba(216, 107, 138, 0.16)"
  },
  motion: {
    fast: "150ms ease",
    standard: "220ms ease"
  },
  icon: {
    nav: 18,
    action: 18,
    kpi: 20,
    hero: 28
  },
  status: {
    success: { bg: "#E6F5EC", fg: "#1F9D6A" },
    warning: { bg: "#FFF8E6", fg: "#B98512" },
    danger: { bg: "#FDEAEA", fg: "#C93636" },
    info: { bg: "#E8F0FB", fg: "#3867C8" },
    neutral: { bg: "#F7ECE7", fg: "#7F6D66" }
  },
  font: {
    heading: "'Plus Jakarta Sans', 'Inter', system-ui, sans-serif",
    body: "'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
  }
} as const;

export const productNavigation = [
  "Command Center",
  "Customers",
  "Orders",
  "Production",
  "Dispatch",
  "Finance",
  "Intelligence",
  "Settings"
] as const;
